/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  withStyles,
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
  Fab,
  MenuItem,
  CircularProgress,
  Typography,
} from '@material-ui/core'
import { Done } from '@material-ui/icons'
import NumberFormat from 'react-number-format'
// import classNames from 'classnames'
// import { REQUEST, SUCCESS } from '../../utils/statusConstants'
import { create, list } from 'actions/data'
import { toggleDialog } from 'actions/view'
import {
  toggleAcquireNumberDisplay,
  searchAvailablePhoneNumbers,
  selectNewPhoneNumber,
  selectUseCase,
} from '../../actions/phonenumbers'
import US from 'utils/flags/US.png'
import CA from 'utils/flags/CA.png'
// import { capitalize, startCase } from 'lodash'
// import { createSelector } from 'reselect'
import { DATA_API_URL } from 'utils/AllURLs'
import { v4 as uuidv4 } from 'uuid'
const mapStateToProps = state => ({
  areaCodeValue: state.phonenumbers.areaCodeValue,
  selectedPhoneNumber: state.phonenumbers.selectedPhoneNumber,
  selectedUseCase: state.phonenumbers.selectedUseCase,
  availablePhoneNumbers: state.phonenumbers.availablePhoneNumbers,
  phonenumbersCount: state.data.phonenumbers
    ? Object.values(state.data.phonenumbers).length
    : 0,
  country: state.data?.account?.mailing?.country,
  customVrAccountId:
    state?.auth?.session?.idToken?.payload?.['custom:vr_account_id'],
  a2p10dlc: Object.values(state.data?.a2p10dlc || {})?.[0],
})

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      toggleAcquireNumberDisplay,
      searchAvailablePhoneNumbers,
      selectNewPhoneNumber,
      create,
      list,
      toggleDialog,
      selectUseCase,
    },
    dispatch,
  )
}

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props

  return (
    <NumberFormat
      {...other}
      allowNegative={false}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        })
      }}
      format="###"
    />
  )
}

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  paragraph: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    padding: '6px 0 7px',
    marginTop: '0px',
    marginBottom: '0px',
  },
  paragraphLabel: {
    marginLeft: theme.spacing.unit,
    fontSize: '11.5px',
  },
  notchedOutline: {
    borderRadius: 28,
    paddingLeft: '13px !important',
  },
  selectNotchedOutline: {
    borderRadius: 28,
    paddingLeft: '40px !important',
  },
  // fab: {
  //   backgroundColor: theme.palette.green,
  // },
  countrySelect: {
    // flexShrink: 0,
    // flexBasis: '10%',
    // [theme.breakpoints.down('sm')]: {
    marginBottom: 10,
    marginTop: 10,
    // },
  },
  selectSection: {
    // flexShrink: 0,
    // flexBasis: '58%',
    // padding: '0 10px',
    position: 'relative',
    // [theme.breakpoints.down('sm')]: {
    padding: 0,
    marginBottom: 5,
    // },
  },
  main: {
    // display: 'flex',
    // alignItems: 'center',
    // [theme.breakpoints.down('sm')]: {
    display: 'block',
    // },
  },
  areaCode: {
    // flexShrink: 0,
    // flexBasis: '25%',
    // [theme.breakpoints.down('sm')]: {
    marginBottom: 10,
    // },
  },
  fab: {
    // flexShrink: 0,
    // [theme.breakpoints.down('sm')]: {
    textAlign: 'right',
    // },
  },
  label: {
    position: 'absolute',
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.56)',
    top: -6,
    backgroundColor: '#fff',
    zIndex: 2,
    textAlign: 'center',
    padding: '0 5px',
    left: 25,
    [theme.breakpoints.down('sm')]: {
      left: 17,
    },
  },
})

class AcquireNumberDisplay extends Component {
  constructor(props) {
    super(props)

    this.state = {
      areaCode: '',
      countryCode: props.country || 'US',
      loading: false,
      useCase: 'MARKETING',
    }
  }

  componentDidMount() {
    this.forceUpdate()
  }

  handleAreaCodeChange = () => event => {
    const areaCode = event.target.value
    Promise.resolve(this.setState({ areaCode })).then(() => {
      if (`${this.state.areaCode}`.length === 3) {
        this.setState({ loading: true })
        this.props
          .searchAvailablePhoneNumbers(
            this.state.areaCode,
            this.state.countryCode,
          )
          .then(() => this.setState({ loading: false }))
      }
    })
  }

  render() {
    const {
      classes,
      // areaCodeValue,
      selectedPhoneNumber,
      availablePhoneNumbers,
      selectNewPhoneNumber,
      // changeAreaCode,
      // searchAvailablePhoneNumbers,
      create,
      phonenumbersCount,
      toggleAcquireNumberDisplay,
      missingAreaCodeText,
    } = this.props

    // const useCases = ['CUSTOMER_CARE', 'MARKETING', 'LOW_VOLUME']

    const availableUseCases = Object.keys(this.props.a2p10dlc?.campaigns || {})

    return (
      <>
        {/* <Typography variant="h5">
					Enter a 3-digit area code to view a list of available phone number
					options.
				</Typography> */}
        <div className={classes.main}>
          <Typography variant="h5" gutterBottom>
            1. First select either the US or Canada
          </Typography>
          <div className={classes.countrySelect} style={{ marginTop: 16 }}>
            <span
              className={classes.item}
              style={{ position: 'relative', marginLeft: 9 }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: -23,
                  left: 1,
                  fontSize: 11,
                  color: 'gray',
                }}
              >
                Country
              </div>
              <Select
                value={this.state.countryCode}
                onChange={e => this.setState({ countryCode: e?.target?.value })}
              >
                <MenuItem value="US">
                  <img
                    src={US}
                    alt="US"
                    style={{
                      marginRight: 5,
                      width: 22,
                      verticalAlign: 'middle',
                    }}
                  />
                  +1
                </MenuItem>
                <MenuItem value="CA">
                  <img
                    src={CA}
                    alt="CA"
                    style={{
                      marginRight: 5,
                      width: 22,
                      verticalAlign: 'middle',
                    }}
                  />
                  +1
                </MenuItem>
              </Select>
            </span>
          </div>
          <Typography variant="h5" gutterBottom>
            2. Then enter an area code in order to select a phone number
          </Typography>
          <div className={classes.areaCode}>
            <FormControl
              // error={Boolean(error)}
              variant="outlined"
              fullWidth
            >
              <InputLabel
                ref={ref => {
                  this.labelRef = ReactDOM.findDOMNode(ref)
                }}
                htmlFor="areacodeinput"
                shrink
                style={{
                  transform: 'translate(18.5px, -6px) scale(0.75)',
                }}
              >
                Area code
              </InputLabel>
              <OutlinedInput
                id="areacodeinput"
                labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
                value={this.state.areaCodeValue}
                onChange={this.handleAreaCodeChange()}
                placeholder="Enter area code"
                notched
                classes={{
                  notchedOutline: classes.notchedOutline,
                }}
                inputComponent={NumberFormatCustom}
              />
              {/* <FormHelperText error={Boolean(error)}>{error}</FormHelperText> */}
            </FormControl>
          </div>
          {this.state.areaCode.length === 3 && (
            <>
              <Typography variant="h5" gutterBottom>
                3. Now select a new phone number from the list below
              </Typography>
              <div
                style={{ marginBottom: 10 }}
                className={classes.selectSection}
              >
                <div className={classes.label}>
                  {this.state.loading
                    ? 'Loading...'
                    : availablePhoneNumbers.length > 1
                    ? 'Your new phone number'
                    : !this.state.areaCode.length
                    ? missingAreaCodeText
                    : 'No available phone numbers for that area code.'}
                </div>
                <FormControl fullWidth variant="outlined">
                  {/* <InputLabel
                ref={ref => {
                  this.selectLabelRef = ReactDOM.findDOMNode(ref)
                }}
                htmlFor="areaCodePhoneNumberSelect"
                shrink
                style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
              >
                {this.state.loading ? (
                  <span>Loading...</span>
                ) : this.state.areaCode.length === 3 &&
                  availablePhoneNumbers.length > 1 ? (
                  <span>Select a new phone number from the list below</span>
                ) : !this.state.areaCode.length ? (
                  <span>{missingAreaCodeText}</span>
                ) : (
                  <span>No available phone numbers for that area code.</span>
                )}
              </InputLabel> */}
                  <Select
                    disabled={availablePhoneNumbers.length <= 1}
                    value={selectedPhoneNumber}
                    onChange={e => selectNewPhoneNumber(e.target.value)}
                    input={
                      <OutlinedInput
                        notched
                        labelWidth={
                          this.selectLabelRef
                            ? this.selectLabelRef.offsetWidth
                            : 0
                        }
                        id="areaCodePhoneNumberSelect"
                        classes={{
                          notchedOutline: classes.selectNotchedOutline,
                        }}
                      />
                    }
                  >
                    {availablePhoneNumbers?.map(number => (
                      <MenuItem
                        key={`areacodePhoneNumber${number.phone_number}`}
                        value={number.phone_number}
                      >
                        {number.number_formatted}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </>
          )}
          {availableUseCases?.length > 1 &&
            selectedPhoneNumber !== 'New phone number' && (
              <>
                <Typography variant="h5" gutterBottom>
                  4. Finally, what do you want to use this phone number for?
                </Typography>
                <div
                  style={{ marginBottom: 10 }}
                  className={classes.selectSection}
                >
                  <div className={classes.label}>
                    {'Select a use case for this number'}
                  </div>
                  <FormControl fullWidth variant="outlined">
                    <Select
                      // disabled={
                      //   this.state.areaCode.length < 3 ||
                      //   availablePhoneNumbers.length <= 1
                      // }
                      value={this.props.selectedUseCase}
                      onChange={e => this.props.selectUseCase(e.target.value)}
                      input={
                        <OutlinedInput
                          notched
                          labelWidth={
                            this.selectLabelRef
                              ? this.selectLabelRef.offsetWidth
                              : 0
                          }
                          id="useCasePhoneNumberSelect"
                          classes={{
                            notchedOutline: classes.selectNotchedOutline,
                          }}
                        />
                      }
                    >
                      {availableUseCases?.map(useCase => (
                        <MenuItem key={`useCase${useCase}`} value={useCase}>
                          {useCase
                            ?.toLowerCase()
                            ?.split('_')
                            ?.map(
                              word =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                            )
                            ?.join(' ')}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </>
            )}
          {/* <div className={classes.selectSection}>
            <div className={classes.label}>Use case</div>
            <FormControl fullWidth variant="outlined">
              <Select
                value={this.state.useCase}
                onChange={e => this.setState({ useCase: e.target.value })}
                input={
                  <OutlinedInput
                    notched
                    labelWidth={
                      this.selectLabelRef ? this.selectLabelRef.offsetWidth : 0
                    }
                    id="useCaseSelect"
                    classes={{ notchedOutline: classes.selectNotchedOutline }}
                  />
                }
              >
                {useCases.map(useCase => (
                  <MenuItem key={`useCase${useCase}`} value={useCase}>
                    {capitalize(startCase(useCase))}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div> */}
          <div className={classes.fab}>
            {this.state.loading ? (
              <CircularProgress />
            ) : (
              <Fab
                style={{ backgroundColor: '#15b940' }}
                disabled={
                  selectedPhoneNumber === 'New phone number' ||
                  this.state.areaCode?.length !== 3
                }
                // classes={{ root: classes.fab }}
                color="secondary"
                size="small"
                onClick={() => {
                  this.setState({ loading: true })

                  create({
                    entity: {
                      phone_number: selectedPhoneNumber,
                      default: !phonenumbersCount,
                    },
                    entityType: 'phonenumbers',
                    path: 'phonenumbers/acquire',
                  }).then(createPayload => {
                    // this.setState({ loading: false })
                    // toggleAcquireNumberDisplay()
                    if (this.props.a2p10dlc?.id) {
                      const requestUUID = uuidv4()

                      create({
                        entityType: 'a2p10dlc',
                        entity: {
                          requestUUID,
                          requests: {
                            [requestUUID]: {
                              directive: 'step_6',
                              createdAt: new Date().toISOString(),
                              updatedAt: new Date().toISOString(),
                            },
                          },
                          directive: 'step_6',
                          id: this.props.a2p10dlc.id,
                          messaging_service_sid:
                            this.props.a2p10dlc.messagingServices?.[
                              this.props.selectedUseCase
                            ]?.sid,
                          phone_number_sid: createPayload?.phone_number_sid,
                        },
                        noReturnValue: true,
                        url: `${DATA_API_URL}/a2p10dlc`,
                        hasSchema: false,
                        snackbarMessage: 'none',
                      }).then(payload => {
                        this.setState({ loading: false })
                        toggleAcquireNumberDisplay()
                        selectNewPhoneNumber('New phone number')
                      })
                    } else {
                      this.props
                        .list('a2p10dlc', null, `${DATA_API_URL}/a2p10dlc`)
                        .then(payload => {
                          console.log('a2p10dlc payload', payload)
                          if (
                            // this.props.customVrAccountId === '111' || this.props.customVrAccountId === '220'
                            !payload?.response?.length // ||
                            // true /* replace this with checking if they haven't applied for that campaign yet */
                          ) {
                            this.props.toggleDialog({
                              open: true,
                              dialog: 'A2P10DLC',
                              options: {
                                createPayload,
                              },
                            })
                          }

                          this.setState({ loading: false })
                          toggleAcquireNumberDisplay()
                          selectNewPhoneNumber('New phone number')
                        })
                    }
                  })
                }}
              >
                <Done />
              </Fab>
            )}
          </div>
        </div>
      </>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(AcquireNumberDisplay))
